export default __webpack_public_path__ + "static/media/checked.74d1da68.png";